<template>
  <div class="flex flex-col lg:flex-row w-full lg:space-x-3 lg:space-y-0 campaign-buttons">

    <a v-if="!this.campaign.pledge_drive" @click="openDonationModal"
      class="cursor-pointer bg-pink hover:bg-pink-600 border-2 border-transparent text-white block font-medium uppercase text-center mb-3 md:mb-0 lg:px-12 py-3 text-sm rounded-full transform transition-all duration-500">
      {{linkText}}
    </a>

    <a v-if="!this.campaign.pledge_drive"
      :href="'/create-my-campaign/' + this.campaignId"
      class="bg-white border-2 border-blue hover:border-pink hover:text-pink text-blue block font-medium uppercase text-center py-3 text-sm rounded-full lg:px-8 transform transition-all duration-500">
      Fundraise for this Campaign
    </a>

    <button  v-if="this.campaign.pledge_drive" @click="openMakePledgeModal" class="cursor-pointer bg-pink hover:bg-pink-700 border-2 border-transparent text-white block py-3 lg:px-3 font-medium uppercase text-center w-full text-sm focus:outline-none  focus:ring-pink-200">Make a Pledge</button>
    <a  :href="'/create-pledge-drive/' + this.campaignId" v-if="this.campaign.pledge_drive" class="cursor-pointer bg-blue hover:bg-blue-700 border-2 border-transparent text-white block py-3 lg:px-3 font-medium uppercase text-center w-full text-sm focus:outline-none  focus:ring-blue-200">Support Our Drive</a>
    <button  v-if="this.campaign.pledge_drive"  @click="openDonationModal" class="bg-white border-2 border-pink text-pink block py-3 lg:px-3 font-medium uppercase text-center w-full text-sm hover:border-pink-700 hover:text-pink-700 focus:outline-none  focus:ring-pink-200">Donate</button>


    <make-donation-widget slot="body" :campaign-id="campaignId" :pledge-id="pledgeId" :campaign="campaign" :key="`gen_don_`+campaignId"></make-donation-widget>

    <make-pledge-widget  slot="body"  :campaign-id="campaignId"  :campaign="campaign" :key="`gen_ple_`+campaignId"></make-pledge-widget>

  </div>
</template>

<script>
  import Modal from '../ui/Modal'
  import MakeDonationWidget from '../make-donation/MakeDonationWidget'
  import MakePledgeWidget from '../campaigns/campaign-page/pledge-drives/MakePledgeWidget'


  export default {
    name: 'MyDonateButton',

    components: { MakePledgeWidget, MakeDonationWidget, Modal },

    props: {
      campaignId: {
        required: true,
        type: String,
      },

      campaign: {
        required: false,
      },

      pledgeId: {
        required: false,
        default: '',
      },

      linkClass: {
        type: String,
        required: false,
        default: 'btn btn-lg btn-block btn-primary',
      },

      fundraiseLinkClass: {
        type: String,
        required: false,
        default: 'btn btn-blue-inverse',
      },

      btnClass: {
        type: String,
        required: false,
        default: 'campaign-buttons',
      },

      linkText: {
        type: String,
        required: false,
        default: 'DONATE',
      },

      showFundraiseButton: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data() {
      return {
        isOpen: false,
        donationModalIsOpen: false,
        isSaving: false,
        pledgeForm: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          amount: null,
          amount_limit: null,
          pledge_drive_id: (this.campaign && this.campaign.pledge_drive) ? this.campaign.pledge_drive.id : '',
          campaign_id: this.campaign.id,
        },
      }
    },

    methods: {
      openDonationModal() {
        this.emitter.emit('open-donation-modal');
      },
      openMakePledgeModal() {
        this.emitter.emit('open-pledge-modal');
      },
    },
    computed: {
      shouldShowFundraiseButton() {
        if (!this.showFundraiseButton) {
          return false
        }
        if (this.campaign && this.campaign.isSupportingPledgeDrive) {
          // do not show if pledge drive campaign is not foundation.
          return false
        }
        return this.showFundraiseButton
      },
      shouldShowMakePledgeButton() {
        if (!this.showFundraiseButton) {
          return false
        }
        if (this.campaign.isSupportingPledgeDrive) {
          return true
        }
        return false
      },
      getButtonText() {
        if (this.campaign.isFoundationPledgeDrive) {
          return 'JOIN OUR PLEDGE DRIVE'
        }
        return 'Fundraise for this Campaign'
      },
      getButtonLink() {
        if (this.campaign.isFoundationPledgeDrive) {
          return '/create-pledge-drive/' + this.campaignId
        }
        return '/create-my-campaign/' + this.campaignId
      },
      disablePledgeButton() {
        if (this.campaign && this.campaign.pledge_drive && this.campaign.pledge_drive.hasEnded) {
          return 'disabled'
        }
        return ''
      },
      makeAPledgeText() {
        if (this.campaign.pledge_drive.hasEnded) {
          return 'Pledge Drive Ended'
        }
        return 'Make A Pledge'
      },
    },
    mounted() {
      this.emitter.on('open-donation-modal-from-campaign', this.openDonationModal);
    },
    beforeUnmount() {
      this.emitter.off('open-donation-modal-from-campaign', this.openDonationModal);
    }
  }
</script>

<style scoped>

</style>
